import i,{css as e,keyframes as t}from"styled-components";import"react";import n from"prop-types";import{calculateRem as o}from"@vds-core/utilities";import{ColorTokens as a}from"@vds-tokens/color";const r={viewport:n.oneOf(["mobile","desktop","tablet"]),fullScreenDialog:n.bool,animationDistance:n.number,borderRadius:n.string},l=i=>{const{exp:e,sqrt:t,sin:n,cos:o}=Math;return-13*e(-13*i)*n(t(31)*i)/t(31)-e(-13*i)*o(t(31)*i)+1},d=(i,e,t)=>i+t*(e-i),p=()=>{let i=[],e=[];for(var t=0;t<=40;t++){let n=l(t/100),o=d(0,"undefined"!=typeof window&&window.innerHeight,n);i.push(o),e.push("undefined"!=typeof window&&window.innerHeight-o)}return{distVals:i,inVals:e}},m=(i,e=!1)=>"mobile"===i?e?"0px":"0px 0px 0px 12px":e?"48px 0px 48px 0px":"48px 0px 48px 42px";function s(i,e){return"in"===i?t`
  0% {
    transform: translateY(${e}px);
  }
  100% {
    transform: translateY(0);
  }
`:(i=>t`
  0% {
    transform: translateY(0px);
    opacity: 1;
  }
  100% {
    transform: translateY(${i}px);
    opacity: 0;
  }
`)(e)}const u=i.div.withConfig({displayName:"ModalDialog",componentId:"VDS__sc-1m9nirl-0"})`
  background-color: ${({surface:i})=>"dark"===i?a.background.primary.dark.value:a.background.primary.light.value};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-flow: column nowrap;
  height: 99.7%;
  line-height: ${o(16)};
  min-height: ${o(232)};
  position: relative;
  width: 100%;
  outline: none;
  border-radius: ${({borderRadius:i})=>i};
  ${({modalOpened:i,viewport:t,fullScreenDialog:n,disableAnimation:o})=>i&&("tablet"===t&&!n||"desktop"===t)&&!o&&e`
      animation: 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s
        ${({animationDistance:i})=>s("in",i)};
    `};

  ${({unmounted:i,viewport:t,fullScreenDialog:n,disableAnimation:o})=>i&&("tablet"===t&&!n||"desktop"===t)&&!o&&e`
      animation: ${({animationDistance:i})=>s("out",i)}
        0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    `};
  ${({modalOpened:i,viewport:n,fullScreenDialog:o,disableAnimation:a})=>i&&("mobile"===n||"tablet"===n&&o)&&!a&&e`
      animation: ${(i=>{let e="";return i.map(((t,n)=>{e+=`${n/i.length*100}% {top: ${t}px }`})),t`${e}`})(p().inVals)} 400ms linear 0s;
    `};

  ${({unmounted:i,viewport:n,fullScreenDialog:o,disableAnimation:a})=>i&&("mobile"===n||"tablet"===n&&o)&&!a&&e`
      animation: ${(i=>{let e="";return i.map(((t,n)=>{e+=`${n/i.length*100}% {top: ${t}px }`})),t`${e}`})(p().distVals)} 400ms linear 0s;
    `};

  ${({viewport:i,modalWidth:t,fullScreenDialog:n})=>"mobile"!==i&&!n&&e`
      @media (min-width: 767px) {
        height: ${({modalHeight:i})=>i?`${i+96}px`:"auto"}; /* Hard coded value accounting for vds ModalDialogWrapper's margin and padding */
        ${t?`\n              width: ${t}; // Don't apply calculateRem because user might pass %, vw, px, or number\n              max-width: 70vw;\n            `:`width: ${o(560)};`};
        max-height: 70vh;
      }
    `};

  @media (min-width: 767px) {
    padding: ${({fullWidthContent:i})=>m("desktop",i)};
  }

  padding: ${({viewport:i,fullWidthContent:e})=>m(i,e)};

  @media (max-width: 767px) {
    padding: ${({fullWidthContent:i})=>m("mobile",i)};
    border-radius: 0;
  }

  ${({fullScreenDialog:i,viewport:e,mobileHeight:t})=>i||"mobile"===e&&`\n    height: ${t} !important;\n    width: 100vw !important;\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  `};

  min-height: ${({viewport:i})=>"mobile"===i&&"100%"};

  @media (max-width: 767px) {
    min-height: 100%;
  }
`;u.propTypes=r,u.defaultProps={viewport:"desktop",fullScreenDialog:!1,animationDistance:150};export{u as default};
